import produce from 'immer'

import ActionTypes from './ActionTypes'

/** @type {ISettingState} */
export const initialState = {
  isInit: false,
  data: [],
}

export default produce(
  /**
   *  @param {ISettingState} draft
   *  @param {IAction} action
   */
  (draft, action) => {
    switch (action?.type) {
      case ActionTypes.INIT: {
        draft.isInit = true
        break
      }
      case ActionTypes.UPDATE_DATA: {
        const { data } = action.payload
        draft.data = data
        break
      }
      default:
        break
    }
  },
  initialState,
)
